module.exports = __webpack_public_path__ + "static/img/introDownload.14c67758.png";